// Colors
export const storiedOrange = "#fa8152";
export const storiedOrangeHover = "#f06c34";
export const storiedDisabled = "#7a7272";
export const storiedDark = "#2D2318";
export const storiedInactive = "#C1C1C1";
export const lowOpacityStoriedOrange = `${storiedOrange}14`; // Add "14" for 8% opacity
